"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  capitalize: true,
  useForkCallback: true
};
Object.defineProperty(exports, "capitalize", {
  enumerable: true,
  get: function () {
    return _capitalize.default;
  }
});
Object.defineProperty(exports, "useForkCallback", {
  enumerable: true,
  get: function () {
    return _useForkCallback.default;
  }
});
var _capitalize = _interopRequireDefault(require("./capitalize"));
var _useForkCallback = _interopRequireDefault(require("./useForkCallback"));
var _shouldForwardProps = require("./shouldForwardProps");
Object.keys(_shouldForwardProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shouldForwardProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shouldForwardProps[key];
    }
  });
});
